import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";

export const promptError = (t) => {
  const n = t.trim().replace(/\s+/g, " ").length;
  return n < 3 || n > 80 ? "Use 3–80 characters." : null;
};

export default function PromptDialog({ prompt, onOpenChange, onSaved }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => { if (prompt) { setText(prompt.text); setError(null); } }, [prompt]);
  const invalid = promptError(text);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSaved((await api(`/admin/prompts/${prompt.id}`, { method: "PATCH", body: { text: text.trim() } })).prompt);
      onOpenChange(false);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={!!prompt} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-[20px]" data-testid="prompt-edit-dialog">
        <form onSubmit={submit} className="space-y-5">
          <DialogHeader>
            <DialogTitle>Edit prompt</DialogTitle>
            <DialogDescription>Used by {prompt?.usage_count ?? 0} profiles. Existing answers keep the text they answered.</DialogDescription>
          </DialogHeader>
          <div>
            <Label htmlFor="pe-text">Prompt text</Label>
            <Input id="pe-text" value={text} onChange={(e) => setText(e.target.value)} maxLength={80} className="mt-2" aria-invalid={!!invalid} data-testid="prompt-edit-text-input" />
            <p className={`mt-2 text-xs ${invalid ? "cw-error" : "cw-muted"}`}>{text.trim().length}/80 · {invalid || "Looks good."}</p>
          </div>
          {error && <p className="cw-error text-sm" role="alert" data-testid="prompt-edit-error">{error}</p>}
          <DialogFooter><Button type="submit" disabled={busy || !!invalid || text.trim() === prompt?.text} data-testid="prompt-edit-save-button">{busy ? "Saving…" : "Save"}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
